import styles from './ResponseMapping.module.css';
import { ENGAGEMENT_ACTION_COPY, requiredEngagementMappingSuggestion } from './engagement-action-copy';

interface RequiredResponseMappingProps {
  outputName: string;
  suggestedPath: string | null;
  onApplySuggestion: (path: string, outputName: string) => void;
}

export const RequiredResponseMapping = ({
  outputName,
  suggestedPath,
  onApplySuggestion,
}: RequiredResponseMappingProps) => (
  <div className={styles.requiredMapping} role="alert">
    <div>
      <strong>{ENGAGEMENT_ACTION_COPY.requiredMappingTitle}</strong>
      <p>
        {ENGAGEMENT_ACTION_COPY.requiredMappingDescriptionLead} <code>{outputName}</code>.
      </p>
    </div>
    {suggestedPath ? (
      <button
        type="button"
        aria-label={requiredEngagementMappingSuggestion(suggestedPath, outputName)}
        onClick={() => onApplySuggestion(suggestedPath, outputName)}>
        {ENGAGEMENT_ACTION_COPY.requiredMappingSuggestionLead} <code>{suggestedPath}</code>{' '}
        {ENGAGEMENT_ACTION_COPY.requiredMappingSuggestionConnector} <code>{outputName}</code>
      </button>
    ) : (
      <p>{ENGAGEMENT_ACTION_COPY.requiredMappingSamplePrompt}</p>
    )}
  </div>
);
